import { DefaultFetchError, FetchCreate, useFetchCreate } from '../fetch';

export interface GetIbanInfoParams {
  bankIdentifier: string
}
export interface GetIbanInfoRes {
  bank: string;
  bic: string;
}
export const useCheckBank = (): FetchCreate<GetIbanInfoRes, DefaultFetchError, GetIbanInfoParams> => (
  useFetchCreate('proxy/check-bank')
);

export interface UpdateBankAccountParams {
  accountOwnerName: string;
  contractNumber: string;
  customerInformed: boolean;
  iban: string;
  periodStart: string;
}
// TODO upd link when Vova create separate request
export const useUpdateBankAccount = (): FetchCreate<
  Record<string, string>, DefaultFetchError, UpdateBankAccountParams> => (
  useFetchCreate('proxy/portal/bankaccount/updateBankAccount')
);
